import { createSlice } from '@reduxjs/toolkit';
import { ITicketTemplateSliceInitials } from './types';
import { ThunkClientPortalConfigurations } from './thunks/clientPortalConfigurationsOptions';
import { ThunkClientPortalCompanies } from './thunks/clientPortalCompanies';
import { storeResources } from '../resources';

const initialState: ITicketTemplateSliceInitials = {
  ticketTemplate: undefined,
  clientPortalConfigurations: [],
  clientPortalCompanies: [],
};

const ticketTemplatesSlice = createSlice<ITicketTemplateSliceInitials, any, 'ticketTemplates'>({
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(ThunkClientPortalConfigurations.fulfilled, (state, { payload }) => {
      state.clientPortalConfigurations = payload;
    });
    builder.addCase(ThunkClientPortalCompanies.fulfilled, (state, { payload }) => {
      state.clientPortalCompanies = payload;
    });
  },
  name: storeResources.TICKET_TEMPLATES as 'ticketTemplates',
});

export default ticketTemplatesSlice.reducer;
